/* eslint-disable no-restricted-globals */
export class UrlHelpers {
    static prepareUrl(inputUrl: any): string {
        if (!inputUrl) {
        return;
        }
        let url = (typeof inputUrl === "string") ? inputUrl : inputUrl.toString();
        let baseUrl = process.env.REACT_APP_API_URL
        if (baseUrl.startsWith('/')) {
            if (url.startsWith('https://media.test.bazaart.com')) {
                url = url.replace('https://media.test.bazaart.com', '/media-test');
            } else if (url.startsWith('https://media.bazaart.com')) {
                url = url.replace('https://media.bazaart.com', '/media');
            } else if (url.startsWith('https://d2ch1c8885oq0w.cloudfront.net')) {
                url = url.replace('https://d2ch1c8885oq0w.cloudfront.net', '/cloudfront');
            } else if (url.startsWith('https://local.design.bazaart.com:3000/cloudfront')) {
                url = url.replace('https://local.design.bazaart.com:3000/cloudfront', '/cloudfront');
            }
        }
        return url;
    }

    static dataURIToBlob(dataURI: string, isPNG = false) {
        let array, binary, i, len
        if (dataURI.indexOf(',') > 0) {
        binary = atob(dataURI.split(',')[1])
        } else {
        binary = atob(dataURI)
        }

        array = []
        i = 0
        len = binary.length
        while (i < len) {
        array.push(binary.charCodeAt(i))
        i++
        }
        let mimType = isPNG ? 'image/png' : 'image/jpg';
        return new Blob([new Uint8Array(array)], {
        type: mimType
        })
    }

    static async base64ToBlobUrl(base64:string | null, isPNG = false): Promise<string | null> {
      if (!base64) {
        return Promise.resolve(null);
      }
        if (typeof URL !== 'undefined' && typeof URL.createObjectURL === 'function') {
            let base64NoPrefix = base64.split(',').reverse()[0]
            let dataURI = await UrlHelpers.dataURIToBlob(base64NoPrefix, isPNG)
            let url = await URL.createObjectURL(dataURI)
            return url
        } else { // service worker doesn't have a createObjectURL method 
            if (/^data:/i.test(base64)) return base64; // already a data URI
            const mime = isPNG ? 'image/png' : 'image/jpeg';
            const result =`data:${mime};base64,${base64}`;
            return Promise.resolve(result);
        }
    }

    static async revokeObjectURLSmart(blobUrl: string): Promise<boolean> {
        // Window (or worker) path
        if (!this.isServiceWorkerScope() && typeof URL?.revokeObjectURL === 'function') {
            URL.revokeObjectURL(blobUrl);
            return;
        }

        // Service Worker path: ask a window client to revoke it
        const sw = self as unknown as ServiceWorkerGlobalScope;
        const clientsList = await sw.clients.matchAll({ type: 'window', includeUncontrolled: true });
        const target = (clientsList as Array<WindowClient & { visibilityState?: 'hidden' | 'visible' }>)
            .find(c => c.visibilityState === 'visible') || clientsList[0];
        if (!target) return; // no client to handle; best-effort

        await new Promise<void>((resolve) => {
            const mc = new MessageChannel();
            mc.port1.onmessage = () => resolve();
            (target as any).postMessage({ type: 'REVOKE_OBJECT_URL', blobUrl }, [mc.port2]);
        });
    }

    static async createObjectURLSmart(blob: Blob): Promise<string> {
      if (typeof URL !== 'undefined' && typeof URL.createObjectURL === 'function' && !this.isServiceWorkerScope()) {
        let imageBlobUrl = URL.createObjectURL(blob); // window or dedicated worker
        // @ts-ignore
        return await window.mediaImageRepositoryProcessing.convertToHeicToJpegIfNeeded(imageBlobUrl);
      }
      // Service Worker path: ask a window to create the blob: URL
      return await this.requestClientToCreateObjectURL(blob);
    }
    
    private static isServiceWorkerScope(): boolean {
      // Light heuristic: Service Worker global has clients + registration; window doesn’t.
      return typeof self !== 'undefined' && 'clients' in self && 'registration' in self && typeof (self as any).skipWaiting === 'function';
    }
    
    private static async requestClientToCreateObjectURL(blob: Blob): Promise<string> {
      const sw = self as unknown as ServiceWorkerGlobalScope;
      const clientsList = await sw.clients.matchAll({ type: 'window', includeUncontrolled: true });
    
      // Prefer a visible (focused) client if available
      const target = (clientsList as Array<WindowClient & { visibilityState?: 'hidden' | 'visible' }>)
        .find(c => c.visibilityState === 'visible') || clientsList[0];
    
      if (!target) {
        throw new Error('No window client available to create object URL');
      }
    
      return new Promise<string>((resolve, reject) => {
        const mc = new MessageChannel();
        mc.port1.onmessage = (ev) => {
          const { url, error } = ev.data || {};
          if (error) reject(new Error(error));
          else if (typeof url === 'string') resolve(url);
          else reject(new Error('Client did not return a URL'));
        };
        // Send blob to client; it will respond on mc.port1
        (target as any).postMessage({ type: 'CREATE_OBJECT_URL', blob }, [mc.port2]);
      });
    }
    

    static blobUrlToBase64(blobUrl:string | URL): Promise<string> {
        return fetch(blobUrl)
            .then(response => response.blob()) // Fetch the blob from the blob URL
            .then(blob => {
            return new Promise<string>((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                const base64data = reader.result as string;
                resolve(base64data.split(',')[1]); // Remove the 'data:' prefix and get base64 content
                };
                reader.onerror = (error) => {
                reject(error);
                };
                reader.readAsDataURL(blob); // Convert Blob to Base64 string
            });
            }).catch((error) => {
            console.error(`error ${error}`)
            return null;
            });
    }



}
